if (!customElements.get('fm-product-addons')) {
  customElements.define(
    'fm-product-addons',
    class ProductAddons extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onCardClick.bind(this));
        this.querySelectorAll('.fm-addons__group').forEach((group) => {
          const track = group.querySelector('.fm-addons__track');
          track?.addEventListener('scroll', () => this.updateArrows(group), { passive: true });
          requestAnimationFrame(() => this.updateArrows(group));
        });
        this.initializeForm();
      }

      initializeForm() {
        const setup = () => {
          this.form = document.getElementById(this.dataset.formId);
          if (!this.form || this.form.dataset.fmAddonsReady === 'true') return;

          this.form.dataset.fmAddonsReady = 'true';
          this.productForm = this.form.closest('product-form');
          const paymentButton = this.productForm?.querySelector('.shopify-payment-button');
          if (paymentButton) paymentButton.hidden = true;
          const submitButton = this.productForm?.querySelector('[type="submit"]');
          submitButton?.classList.remove('button--secondary');
          submitButton?.classList.add('button--primary');
          this.form.addEventListener('submit', this.onSubmit.bind(this), true);
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', setup, { once: true });
        } else {
          setup();
        }
      }

      onCardClick(event) {
        const previous = event.target.closest('[data-addon-prev]');
        const next = event.target.closest('[data-addon-next]');
        if (previous || next) {
          const group = event.target.closest('.fm-addons__group');
          const track = group?.querySelector('.fm-addons__track');
          if (!track) return;
          track.scrollBy({ left: track.clientWidth * (previous ? -0.82 : 0.82), behavior: 'smooth' });
          return;
        }

        if (event.target.closest('[data-addon-dialog-close]')) {
          this.querySelector('[data-addon-dialog]')?.close();
          return;
        }

        const info = event.target.closest('[data-addon-info]');
        if (info) {
          this.openDialog(info);
          return;
        }

        const select = event.target.closest('[data-addon-select]');
        const card = select?.closest('[data-addon-card]');
        if (!select || !card || !this.contains(card)) return;

        const wasSelected = select.getAttribute('aria-pressed') === 'true';
        const group = card.dataset.addonGroup;

        this.querySelectorAll(`[data-addon-card][data-addon-group="${group}"] [data-addon-select]`).forEach((item) => {
          item.setAttribute('aria-pressed', 'false');
        });

        if (!wasSelected) select.setAttribute('aria-pressed', 'true');
      }

      updateArrows(group) {
        const track = group.querySelector('.fm-addons__track');
        const previous = group.querySelector('[data-addon-prev]');
        const next = group.querySelector('[data-addon-next]');
        if (!track || !previous || !next) return;

        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
      }

      openDialog(info) {
        const dialog = this.querySelector('[data-addon-dialog]');
        if (!dialog) return;

        const image = dialog.querySelector('[data-addon-dialog-image]');
        image.src = info.dataset.image || '';
        image.alt = info.dataset.title || '';
        dialog.querySelector('[data-addon-dialog-title]').textContent = info.dataset.title || '';
        dialog.querySelector('[data-addon-dialog-price]').textContent = info.dataset.price || '';
        dialog.querySelector('[data-addon-dialog-description]').textContent = info.dataset.description || '';

        if (!dialog.dataset.backdropReady) {
          dialog.dataset.backdropReady = 'true';
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
        }
        dialog.showModal();
      }

      async onSubmit(event) {
        const selectedButtons = Array.from(this.querySelectorAll('[data-addon-select][aria-pressed="true"]'));
        if (selectedButtons.length === 0) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitButton = this.productForm?.submitButton || this.form.querySelector('[type="submit"]');
        if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

        const spinner = submitButton.querySelector('.loading__spinner');
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
        spinner?.classList.remove('hidden');
        this.productForm?.handleErrorMessage();

        const formData = new FormData(this.form);
        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const mainItem = {
          id: Number(formData.get('id')),
          quantity,
        };

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

        const properties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && String(value).trim()) properties[match[1]] = String(value).trim();
        });
        if (Object.keys(properties).length) mainItem.properties = properties;

        const items = [
          mainItem,
          ...selectedButtons.map((button) => ({
            id: Number(button.closest('[data-addon-card]').dataset.variantId),
            quantity: 1,
          })),
        ];

        const payload = { items };
        const cart = this.productForm?.cart;
        if (cart) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }

        try {
          const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            const message = data.description || data.message || 'No se han podido añadir los complementos.';
            this.productForm?.handleErrorMessage(message);
            return;
          }

          window.location = window.routes.cart_url;
        } catch (error) {
          console.error(error);
          this.productForm?.handleErrorMessage(error.message || 'Network error');
        } finally {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }
      }
    }
  );
}
